import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { Constants } from 'src/app/constants';
import { ExcelService } from 'src/app/service/excel.service';

@Component({
    selector: 'app-grid-error-warning',
    templateUrl: './grid-error-warning.component.html',
    styleUrls: ['./grid-error-warning.component.scss'],
    standalone: false
})
export class GridErrorWarningComponent implements OnInit {
  heading;
  eventType;
  errormsg
  gridApi: any;
  columnDefs = [];
  displayRowData = [];
  context: {};
  currentPageNo: number;
  currentPageBoolean: boolean = false;
  export: boolean = false;
  totalPage: number;
  currentPageForTotalPage: number;
  isLastPageFound: boolean;
  rowCount: number;
  defaultColDef: {};
  gridOptions
  icons: {};
  constructor(public dialogRef: MatDialogRef<GridErrorWarningComponent>, private readonly constants: Constants,private readonly excelService: ExcelService,
    @Inject(MAT_DIALOG_DATA) public dataStore: any,) {
    this.context = {
      componentParent: this
    };
    this.defaultColDef = {
      suppressMovable: true, wrapText: true,

    }
    this.icons = {
      sortUnSort: '<img src="./assets/images/unsort.svg">',
    };
  }

  ngOnInit(): void {
    this.heading = this.dataStore.header;
    this.export = this.heading == "SAP Verification - Success"  // NOSONAR
    this.eventType = this.dataStore.eventType
    this.displayRowData = this.dataStore.displayRowData;
    this.rowCount = this.dataStore.displayRowData.length;
    if (this.eventType == "ERROR") {  // NOSONAR
      this.columnDefs = [
        {
          headerName: "", minWidth:50, maxWidth:50,  autoHeight: true, wrapText: true,
          cellRenderer: (params) => {
            if (params.data.type == "warning")  // NOSONAR
              {return '<mat-icon class="mat-icon material-icons" style="color:red" role="img">warning</mat-icon>'}
            else
              {return '<mat-icon class="mat-icon material-icons" style="color:red" role="img">cancel</mat-icon>'}
          }  
        },
        {
          headerName: "Row", minWidth:75, maxWidth:75, autoHeight: true, wrapText: true, field: "row"
        },
        {
          headerName: "Column",minWidth:75, maxWidth:75, autoHeight: true, wrapText: true, field: "column"
        },
        {
          headerName: "Field(s)",  autoHeight: true, wrapText: true, field: "field"
        },
        {
          headerName: "Value",  autoHeight: true, wrapText: true, field: "value"
        },
        {
          headerName: "Message",  autoHeight: true, wrapText: true, field: "message"
        }
      ]
    } else if (this.eventType == "SUCCESS") {  // NOSONAR
      this.columnDefs = [
        {
          headerName: "Container", width: 60, autoHeight: true, wrapText: true, field: "container"
        },
        {
          headerName: "Waybill", width: 60, autoHeight: true, wrapText: true, field: "wayBill"
        },
        {
          headerName: "Back", width: 30, autoHeight: true, wrapText: true, field: "backNum"
        },
        {
          headerName: "ASN KG", width: 30, autoHeight: true, wrapText: true, field: "asnKg", cellStyle: this.cellStyling, valueFormatter: this.formatNumber
        },
        {
          headerName: "SAP KG", width: 30, autoHeight: true, wrapText: true, field: "sapKg", cellStyle: this.cellStyling, valueFormatter: this.formatNumber
        },
        {
          headerName: "ASN Qty", width: 30, autoHeight: true, wrapText: true, field: "asnQty", cellStyle: this.cellStyling
        },
        {
          headerName: "SAP Qty", width: 30, autoHeight: true, wrapText: true, field: "sapQty", cellStyle: this.cellStyling
        },
        {
          headerName: "Qty Match", width: 30, autoHeight: true, wrapText: true, field: "qtyMatch"
        }, {
          headerName: "KG Match", width: 30, autoHeight: true, wrapText: true, field: "kgMatch"
        }
      ]
    }


  }

  formatNumber(params: any): string {
  if (!params.value) return '';

  let num = params.value.toString();

  if (num.includes('.')) {
    num = num.substring(0, num.indexOf('.') + 4); // max 3 decimals
    num = num.replace(/\.?0+$/, '');
  }

  return num;
}
  cellStyling(_params) {
    return { 'background-color': 'red', 'color': 'black' };
  }

  onBtExport(){
    if (this.displayRowData?.length > 0 ) {
        const exportData = [];
        this.displayRowData.forEach(e => {
          const obj = {
            Container: e.container,
            Waybill: e.wayBill,
            Back: e.backNum,
            asnKg: this.formatExport(e.asnKg),
            sapKg: this.formatExport(e.sapKg),
            asnQty: this.formatExport(e.asnQty),
            sapQty: this.formatExport(e.sapQty),
            qtyMatch: e.qtyMatch,
            kgMatch: e.kgMatch
          };
          exportData.push(obj);
        });

        const headers = ['Container', 'Waybill', 'Back', 'ASN KG', 'SAP KG', 'ASN Qty', 'SAP Qty', 'Qty Match', 'KG Match'];
        this.excelService.exportAsExcelFile(exportData, 'SAP Verification', headers);
    }
  }

  formatExport(value: any): string {
  if (value === null || value === undefined) return '';

  let str = value.toString();

  if (str.includes('.')) {
    // keep up to 3 decimals (no rounding)
    str = str.substring(0, str.indexOf('.') + 4);

    // remove trailing zeros
    str = str.replace(/\.?0+$/, '');
  }

  return str;
}

  goToNexpage() { this.gridApi.paginationGoToNextPage(); }

  goToPreviousPage() { this.gridApi.paginationGoToPreviousPage() }

  goToFirstPage() { this.gridApi.paginationGoToFirstPage(); }

  goToLastPage() { this.gridApi.paginationGoToLastPage()  }

  getCurrentPage(): boolean {
    this.currentPageNo = this.gridApi?.paginationGetCurrentPage();
    if (this.currentPageNo == 0) {  // NOSONAR
      this.currentPageBoolean = true;
    }
    else { this.currentPageBoolean = false; }
    return this.currentPageBoolean;
  }
  isLastPage(): boolean {
    this.totalPage = Number(this.gridApi?.paginationGetTotalPages());
    this.currentPageForTotalPage = Number(this.gridApi?.paginationGetCurrentPage()) + 1;
    if (this.totalPage == this.currentPageForTotalPage) {  // NOSONAR
      this.isLastPageFound = true;
    }
    else {
      this.isLastPageFound = false;
    }
    return this.isLastPageFound;
  }
  onGridReady(params) {
    this.gridApi = params.api
    this.gridApi.sizeColumnsToFit();
  }

  getRowHeight() {
    return 30;
  }
  sizeToFit() {
    this.gridApi?.sizeColumnsToFit();
  }

  onPageSizeChanged(event: any) {
    if (event.target.value == "ALL")  // NOSONAR
      {this.gridApi?.setGridOption('paginationPageSize', Number(this.displayRowData.length));}
    else
      {this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value));}
  }
  setGridData(): void {
    this.gridApi?.setGridOption('rowData', this.displayRowData);
    this.rowCount = this.displayRowData.length;
    this.gridApi?.resetRowHeights();
  }

  close(): void {
    this.dialogRef.close(
      { event: 'CloseEvent' }
    );
  }



}
